// @ts-nocheck
/**
 * Purabelle — Custom Bundle Builder (standalone side-controller)
 * Fil: assets/purabelle-bundle-builder.js
 *
 * Forbruger den delte motor i window.PurabelleBundleCore (samme pris-/lager-/
 * kurv-logik som PDP-modulet). Implementerer en "fast boks"-flow:
 *   1) vælg størrelse  2) vælg antal flasker (N)  3) fyld N pladser
 *   pris = fast tier-pris(size, N) — håndteres natively af Shopify-rabatten.
 */
(function () {
  'use strict';

  const Core = window.PurabelleBundleCore;
  if (!Core) { console.error('Purabelle: bundle-core mangler'); return; }

  const state = {
    catalog: [],
    byId: new Map(),
    byHandle: new Map(),
    size: '100ml',
    targetQty: 3,
    recommendedQty: 3,
    filter: 'all',
    search: '',
    selected: [], // [{ productId, variantId, title, image, price, isPreorder, quantity }]
    baseBySize: {},
    appliedPresetKey: null, // labelKey af det senest anvendte preset; ryddes ved manuel ændring
  };

  let els = {};
  let userInteracted = false;

  // ─── i18n: læs strenge fra #pbb-i18n string-banken ──────────────────────────
  // Banken renderes server-side på dansk; T LAB oversætter den klient-side ved
  // load. Vi læser teksten LAZY (hver render) så JS-strenge afspejler den
  // oversatte tekst i den engelske visning i stedet for at lække dansk.
  function t(key) {
    const bank = document.getElementById('pbb-i18n');
    const el = bank && bank.querySelector('[data-i18n="' + key + '"]');
    return el ? el.textContent.trim() : key;
  }
  function tf(key, vars) {
    let s = t(key);
    if (vars) for (const k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }

  // ─── Hjælpere ───────────────────────────────────────────────────────────────
  function toList(v) {
    if (Array.isArray(v)) return v.filter(Boolean);
    if (typeof v === 'string' && v.trim()) {
      const str = v.trim();
      if (str.startsWith('[')) { try { return JSON.parse(str); } catch (e) { /* fall through */ } }
      return str.split(',').map(s => s.trim()).filter(Boolean);
    }
    return [];
  }

  function announce(msg) {
    if (!els.live) return;
    els.live.textContent = '';
    window.requestAnimationFrame(() => { els.live.textContent = msg; });
  }

  function variantForSize(product, size) {
    if (!product) return null;
    return product.variants.find(v => (v.size || '').toLowerCase() === (size || '').toLowerCase()) || null;
  }

  function hasAvailableSize(product, size) {
    const v = variantForSize(product, size);
    return !!v && v.available !== false;
  }

  function isPreorderV(v) { return Core.isPreorder(v); }
  // "Kan købes" = available !== false. Dette inkluderer forudbestilling
  // (continue-selling: udsolgt men købbar) og udelukker ægte udsolgte (available=false).
  function isAvailableV(v) { return !!v && v.available !== false; }

  // Single source of truth: the server-computed state ('available' | 'soldout' | 'preorder')
  // from snippets/preorder-state-fields.liquid. Fallback to stock/policy if absent.
  function stateOf(v) {
    if (v && v.state) return v.state;
    if (!v || v.available === false) return 'soldout';
    return Core.isPreorder(v) ? 'preorder' : 'available';
  }

  // Repræsentativ fuld-pris pr. størrelse = hyppigste variantpris (typeprisen).
  function representativeBase(size) {
    if (state.baseBySize[size] != null) return state.baseBySize[size];
    const counts = {};
    state.catalog.forEach(p => {
      const v = variantForSize(p, size);
      if (v && typeof v.price === 'number') counts[v.price] = (counts[v.price] || 0) + 1;
    });
    let best = 0, bestN = -1;
    Object.keys(counts).forEach(price => {
      if (counts[price] > bestN) { bestN = counts[price]; best = parseInt(price, 10); }
    });
    state.baseBySize[size] = best;
    return best;
  }

  function totalSelected() {
    return state.selected.reduce((n, p) => n + (p.quantity || 1), 0);
  }

  function findSelected(productId) {
    return state.selected.find(p => p.productId === productId);
  }

  function bundlePrice() {
    const tier = Core.tierPrice(state.size, state.targetQty);
    if (tier != null) return tier;
    return Core.bundleTotal(state.size, representativeBase(state.size), state.targetQty);
  }

  // ─── Deep-links ─────────────────────────────────────────────────────────────
  // Understøttede query-params:
  //   ?size=100ml|30ml|3ml         forvælg flaskestørrelse
  //   ?qty=2..6                    forvælg antal flasker (boks-størrelse)
  //   ?filter=all|herre|damer      forvælg køns-filter (også: men/women aliases)
  //   ?products=h1,h2,h3           preload specifikke produkt-handles (kappet ved targetQty)
  //   ?preset=<block-id>           auto-anvend et navngivet preset (stabil block.id)
  // Anvendelses-rækkefølge: size -> qty -> filter -> products | preset.
  // 'products' har forrang over 'preset' hvis begge er sat (eksplicit > implicit).
  function applyDeepLink() {
    const p = new URLSearchParams(window.location.search);
    const allowedSizes = Object.keys(Core.CONFIG.bundlePrices); // 100ml,30ml,3ml
    const filterAlias = { men: 'herre', women: 'damer', all: 'all', herre: 'herre', damer: 'damer' };

    const size = p.get('size');
    if (size && allowedSizes.indexOf(size) > -1) state.size = size;

    const qty = parseInt(p.get('qty'), 10);
    if (qty >= 2 && qty <= 6) state.targetQty = qty;

    const filter = p.get('filter');
    if (filter && filterAlias[filter]) state.filter = filterAlias[filter];

    const productsParam = p.get('products');
    const presetKey = p.get('preset');

    if (productsParam) {
      productsParam.split(',').map(s => s.trim()).filter(Boolean).forEach(h => {
        const prod = state.byHandle.get(h);
        if (prod && canAddMore() && hasAvailableSize(prod, state.size)) addOneSilent(prod.id);
      });
    } else if (presetKey) {
      let defs = [];
      const node = document.getElementById('pbb-presets');
      try { defs = node ? JSON.parse(node.textContent) : []; } catch (e) { defs = []; }
      const def = defs.find(d => d.key === presetKey);
      if (def) {
        (def.handles || [])
          .map(h => state.byHandle.get(h))
          .filter(prod => prod && hasAvailableSize(prod, state.size))
          .forEach(prod => { if (canAddMore()) addOneSilent(prod.id); });
        state.appliedPresetKey = presetKey;
      } else {
        console.warn('[bundle-builder] deep-link: ukendt preset key', presetKey);
      }
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  function init() {
    const root = document.getElementById('pbb-root');
    if (!root) return;

    state.size = root.dataset.defaultSize || '100ml';
    state.targetQty = parseInt(root.dataset.defaultQty, 10) || 3;
    state.recommendedQty = parseInt(root.dataset.recommendedQty, 10) || state.targetQty;

    parseCatalog();
    cacheEls();
    bindEvents();
    applyDeepLink();      // ?size,?qty,?filter,?products,?preset → muterer state før UI-sync
    syncSizeButtons();
    syncQtyButtons();
    syncFilterButtons();
    buildPresets();
    renderAll();

    // T LAB oversætter string-banken klient-side EFTER load. Gen-render én gang,
    // så de initiale JS-strenge afspejler oversættelsen (springes over hvis
    // brugeren allerede er i gang — lazy t() dækker efterfølgende renders).
    window.addEventListener('load', () => setTimeout(() => { if (!userInteracted) renderAll(); }, 1500));
  }

  function parseCatalog() {
    const node = document.getElementById('pbb-catalog');
    if (!node) return;
    let raw = [];
    try { raw = JSON.parse(node.textContent); } catch (e) { console.error('Purabelle: katalog-parse fejl', e); }
    raw.forEach(p => {
      const existing = state.byId.get(p.id);
      if (existing) { existing.groups.add(p.group); return; }
      p.groups = new Set([p.group]);
      state.byId.set(p.id, p);
    });
    state.catalog = Array.from(state.byId.values());
    state.catalog.forEach(p => state.byHandle.set(p.handle, p));
  }

  function cacheEls() {
    els = {
      root: document.getElementById('pbb-root'),
      grid: document.getElementById('pbb-grid'),
      slots: document.getElementById('pbb-slots'),
      search: document.getElementById('pbb-search'),
      sizeBtns: document.querySelectorAll('.pbb-size-btn'),
      qtyBtns: document.querySelectorAll('.pbb-qty-btn'),
      filters: document.querySelectorAll('.pbb-filter'),
      atc: document.getElementById('pbb-atc'),
      price: document.querySelector('.pbb-price'),
      saveRow: document.querySelector('.pbb-summary-save'),
      saveAmount: document.querySelector('.pbb-save-amount'),
      savePct: document.querySelector('.pbb-save-pct'),
      reco: document.querySelector('[data-pbb-reco]'),
      recoText: document.querySelector('.pbb-reco-text'),
      recoSave: document.querySelector('.pbb-reco-save'),
      presets: document.querySelector('[data-pbb-presets]'),
      presetChips: document.querySelector('.pbb-presets-chips'),
      progressFill: document.querySelector('.pbb-progress-fill'),
      countCurrent: document.querySelector('.pbb-count-current'),
      countTarget: document.querySelector('.pbb-count-target'),
      preorderNote: document.getElementById('pbb-preorder-note'),
      preorderDetail: document.querySelector('.pbb-preorder-detail'),
      modal: document.getElementById('pbb-modal'),
      modalBody: document.querySelector('.pbb-modal-body'),
      live: document.getElementById('pbb-live'),
      mbCta: document.getElementById('pbb-mb-cta'),
      mbCount: document.querySelector('.pbb-mb-count'),
      mbPrice: document.querySelector('.pbb-mb-price'),
    };
  }

  function bindEvents() {
    els.sizeBtns.forEach(b => b.addEventListener('click', () => selectSize(b.dataset.size)));
    els.qtyBtns.forEach(b => b.addEventListener('click', () => selectQty(parseInt(b.dataset.qty, 10))));
    els.filters.forEach(b => b.addEventListener('click', () => selectFilter(b.dataset.filter, b)));
    let searchTimer;
    els.search.addEventListener('input', (e) => {
      userInteracted = true;
      state.search = e.target.value.toLowerCase();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(renderGrid, 180);
    });
    els.atc.addEventListener('click', handleATC);
    if (els.mbCta) els.mbCta.addEventListener('click', onMobileCta);
    els.modal.querySelectorAll('[data-pbb-close]').forEach(b => b.addEventListener('click', closeDetail));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !els.modal.hidden) closeDetail(); });
  }

  // Mobil-bar CTA: tilføj hvis komplet, ellers scroll til grid for at vælge
  function onMobileCta() {
    if (els.atc && !els.atc.disabled) { handleATC(); return; }
    if (els.grid) els.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── Vælgere ────────────────────────────────────────────────────────────────
  function selectSize(size) {
    if (size === state.size) return;
    userInteracted = true;
    state.appliedPresetKey = null;   // valgsammensætningen kan ændre sig -> ryd applied
    state.size = size;
    // behold valg der findes i den nye størrelse, drop resten
    state.selected = state.selected.filter(p => {
      const prod = state.byId.get(p.productId);
      const v = variantForSize(prod, size);
      if (v && isAvailableV(v)) { p.variantId = v.id; p.price = v.price; p.isPreorder = isPreorderV(v); p.shipDate = v.shipDate || ''; p.shipDateISO = v.shipDateISO || ''; return true; }
      return false;
    });
    syncSizeButtons();
    buildPresets();
    renderAll();
    announce(`Størrelse ${size} valgt.`);
  }

  function selectQty(qty) {
    userInteracted = true;
    state.appliedPresetKey = null;   // trim kan bryde preset-matchet -> ryd applied
    state.targetQty = qty;
    // hvis flere er valgt end den nye boks tillader, trim fra enden
    while (totalSelected() > qty) {
      const last = state.selected[state.selected.length - 1];
      if ((last.quantity || 1) > 1) last.quantity -= 1;
      else state.selected.pop();
    }
    syncQtyButtons();
    renderAll();
    announce(`${qty} flasker valgt.`);
  }

  function selectFilter(filter, btn) {
    userInteracted = true;
    state.filter = filter;
    syncFilterButtons();
    buildPresets();   // presets er køns-kontekstuelle
    renderGrid();
  }

  function syncFilterButtons() {
    els.filters.forEach(b => {
      const active = b.dataset.filter === state.filter;
      b.classList.toggle('active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncSizeButtons() {
    els.sizeBtns.forEach(b => {
      const active = b.dataset.size === state.size;
      b.classList.toggle('active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      const from = b.querySelector('.pbb-size-from');
      const tier = Core.tierPrice(b.dataset.size, state.targetQty);
      if (from && tier) from.textContent = 'fra ' + Core.formatPrice(Math.round(tier / state.targetQty)).replace(' kr.', ' kr/stk');
    });
  }

  function syncQtyButtons() {
    els.qtyBtns.forEach(b => {
      const active = parseInt(b.dataset.qty, 10) === state.targetQty;
      b.classList.toggle('active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // ─── Valg af produkter ────────────────────────────────────────────────────
  function canAddMore() { return totalSelected() < state.targetQty; }

  function addOne(productId) {
    productId = parseInt(productId, 10);
    if (!canAddMore()) { announce('Pakken er fuld. Fjern en flaske for at bytte.'); return; }
    const product = state.byId.get(productId);
    const v = variantForSize(product, state.size);
    if (!v || !isAvailableV(v)) return;
    const maxQ = Core.maxQtyForVariant(v);
    const existing = findSelected(productId);
    if (existing) {
      if ((existing.quantity || 1) >= maxQ) { announce(`Maks. antal nået for ${product.title}.`); return; }
      existing.quantity = (existing.quantity || 1) + 1;
    } else {
      state.selected.push({
        productId, variantId: v.id, title: product.title, image: product.image,
        price: v.price, isPreorder: isPreorderV(v), shipDate: v.shipDate || '', shipDateISO: v.shipDateISO || '', quantity: 1,
      });
    }
    afterChange(`${product.title} tilføjet`);
  }

  function removeOne(productId) {
    productId = parseInt(productId, 10);
    const idx = state.selected.findIndex(p => p.productId === productId);
    if (idx === -1) return;
    const item = state.selected[idx];
    if ((item.quantity || 1) > 1) item.quantity -= 1;
    else state.selected.splice(idx, 1);
    afterChange(`${item.title} opdateret`);
  }

  function removeProduct(productId) {
    productId = parseInt(productId, 10);
    const item = findSelected(productId);
    state.selected = state.selected.filter(p => p.productId !== productId);
    afterChange(`${item ? item.title : 'Vare'} fjernet`);
  }

  function afterChange(msg) {
    userInteracted = true;
    state.appliedPresetKey = null;   // manuel ændring -> preset ikke længere "anvendt"
    if (msg) announce(`${msg}. ${totalSelected()} af ${state.targetQty} i pakken.`);
    renderAll();
  }

  // ─── Presets (data-backed: 12-mdrs "købt sammen"-analyse, se #pbb-presets) ──
  function buildPresets() {
    if (!els.presetChips) return;
    let defs = [];
    const node = document.getElementById('pbb-presets');
    try { defs = node ? JSON.parse(node.textContent) : []; } catch (e) { defs = []; }

    // filtrér efter aktivt køns-filter; resolve handles -> tilgængelige produkter.
    // console.warn ved partiel opløsning så månedlig refresh fanger handle-drift.
    const visible = defs
      .filter(d => state.filter === 'all' || d.group === state.filter)
      .map(d => {
        const requested = d.handles || [];
        const resolved  = requested.map(h => state.byHandle.get(h));
        const missing   = requested.filter((h, i) => !resolved[i]);
        const present   = resolved.filter(Boolean);
        const prods     = present.filter(p => hasAvailableSize(p, state.size));
        const oosInSize = present.filter(p => !hasAvailableSize(p, state.size)).map(p => p.handle);
        if (missing.length)   console.warn('[bundle-builder] preset', d.key || d.labelKey, 'ukendte handles:', missing);
        if (oosInSize.length) console.warn('[bundle-builder] preset', d.key || d.labelKey, 'utilgængelige i', state.size + ':', oosInSize);
        return { labelKey: d.labelKey, key: d.key, prods };
      })
      .filter(d => d.prods.length >= 2);

    if (visible.length === 0) { els.presets.hidden = true; return; }
    els.presets.hidden = false;

    els.presetChips.innerHTML = visible.map((d, i) => {
      const applied = state.appliedPresetKey === d.key;
      const thumbs = d.prods.slice(0, 3).map(p => p.image
        ? `<img src="${p.image}" alt="" loading="lazy">` : '<span class="pbb-preset-ph"></span>').join('');
      const cta = applied ? t('preset_applied') : (t('preset_cta') + ' →');
      return `<button type="button" class="pbb-preset-card${applied ? ' applied' : ''}" data-preset="${i}" aria-pressed="${applied}">
        <span class="pbb-preset-thumbs">${thumbs}</span>
        <span class="pbb-preset-text"><span class="pbb-preset-name">${t(d.labelKey)}</span><span class="pbb-preset-cta">${cta}</span></span>
      </button>`;
    }).join('');

    els.presetChips.querySelectorAll('.pbb-preset-card').forEach(btn => {
      const i = parseInt(btn.dataset.preset, 10);
      btn.addEventListener('click', () => applyPreset(visible[i].prods.map(p => p.id), visible[i].key));
    });
  }

  function applyPreset(productIds, key) {
    userInteracted = true;
    state.selected = [];
    for (const id of productIds) {
      if (!canAddMore()) break;
      addOneSilent(id);
    }
    state.appliedPresetKey = key || null;
    renderAll();
    announce(`Forslag tilføjet. ${totalSelected()} af ${state.targetQty} i pakken.`);
  }

  function addOneSilent(productId) {
    const product = state.byId.get(productId);
    const v = variantForSize(product, state.size);
    if (!v || !isAvailableV(v)) return;
    state.selected.push({
      productId, variantId: v.id, title: product.title, image: product.image,
      price: v.price, isPreorder: isPreorderV(v), shipDate: v.shipDate || '', shipDateISO: v.shipDateISO || '', quantity: 1,
    });
  }

  // ─── Render ─────────────────────────────────────────────────────────────────
  function renderAll() {
    syncSizeButtons();
    renderReco();
    renderGrid();
    renderSlots();
    renderSummary();
    renderProgress();
    renderATC();
  }

  function renderReco() {
    if (!els.reco) return;
    const price = bundlePrice();
    const base = representativeBase(state.size);
    const full = base * state.targetQty;
    const pct = full > 0 ? Math.round((1 - price / full) * 100) : 0;
    els.recoText.textContent = tf('reco', { n: state.targetQty, size: state.size }) + ' — ' + Core.formatPrice(price);
    els.recoSave.textContent = pct > 0 ? tf('save_pct', { pct: pct }) : '';
  }

  function renderGrid() {
    if (!els.grid) return;
    els.grid.setAttribute('aria-busy', 'false');
    const size = state.size;
    const full = totalSelected() >= state.targetQty;

    let list = state.catalog.filter(p => {
      // Keep products that OFFER this size even if it's sold out — they render greyed
      // with "Udsolgt" so the scent stays discoverable. Only hide products that simply
      // don't come in this size.
      if (!variantForSize(p, size)) return false;
      if (state.filter !== 'all' && !p.groups.has(state.filter)) return false;
      if (state.search && !(p.title || '').toLowerCase().includes(state.search)) return false;
      return true;
    });

    const selIds = new Set(state.selected.map(p => p.productId));
    list.sort((a, b) => (selIds.has(b.id) ? 1 : 0) - (selIds.has(a.id) ? 1 : 0));

    if (list.length === 0) {
      els.grid.innerHTML = '<p class="pbb-empty">Ingen parfumer matcher din søgning.</p>';
      return;
    }

    els.grid.innerHTML = list.map(p => {
      const v = variantForSize(p, size);
      const st = stateOf(v);
      const soldout = st === 'soldout';
      const preorder = st === 'preorder';
      const sel = findSelected(p.id);
      const qty = sel ? (sel.quantity || 1) : 0;
      const isSel = qty > 0;
      const maxQ = Core.maxQtyForVariant(v);
      const safe = (p.title || '').replace(/"/g, '&quot;');
      const fam = p.scentFamily ? `<span class="pbb-card-family">${p.scentFamily}</span>` : '';

      const control = soldout
        ? `<button class="pbb-add soldout" type="button" disabled aria-disabled="true">${t('soldout')}</button>`
        : isSel
        ? `<div class="pbb-stepper" role="group" aria-label="Antal ${safe}">
             <button class="pbb-step" type="button" data-act="minus" data-id="${p.id}" aria-label="Fjern én ${safe}">−</button>
             <span class="pbb-step-qty">${qty}</span>
             <button class="pbb-step" type="button" data-act="plus" data-id="${p.id}" aria-label="Tilføj én ${safe}" ${(qty >= maxQ || full) ? 'disabled' : ''}>+</button>
           </div>`
        : `<button class="pbb-add ${preorder ? 'preorder' : ''}" type="button" data-act="add" data-id="${p.id}" ${full ? 'disabled' : ''}>
             ${full ? t('box_full') : preorder ? t('preorder') : t('add')}
           </button>`;

      const stateClass = soldout ? 'soldout' : (preorder ? 'preorder' : '');
      return `
        <div class="pbb-card ${isSel ? 'selected' : ''} ${stateClass}" data-id="${p.id}" tabindex="0" aria-label="Hurtig visning: ${safe}">
          <div class="pbb-card-img">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : '<div class="pbb-card-ph"></div>'}</div>
          <div class="pbb-card-meta">
            <span class="pbb-card-title">${p.title}</span>
            ${fam}
          </div>
          ${gender(p)}
          ${control}
        </div>`;
    }).join('');

    els.grid.querySelectorAll('[data-act]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = btn.dataset.id;
        const act = btn.dataset.act;
        if (act === 'add' || act === 'plus') addOne(id);
        else if (act === 'minus') removeOne(id);
      });
    });
    // Hele kortet åbner Quick View; kontrol-knapperne stopper propagation
    els.grid.querySelectorAll('.pbb-card').forEach(card => {
      const open = () => openDetail(card.dataset.id);
      card.addEventListener('click', open);
      card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
  }

  function gender(p) {
    const g = (p.gender || '').toLowerCase();
    if (g.indexOf('herre') > -1 || p.groups.has('herre')) return '<span class="pbb-tag herre">Herre</span>';
    if (g.indexOf('dame') > -1 || p.groups.has('damer')) return '<span class="pbb-tag damer">Damer</span>';
    return '<span class="pbb-tag unisex">Unisex</span>';
  }

  function renderSlots() {
    if (!els.slots) return;
    const chips = [];
    state.selected.forEach(p => {
      for (let i = 0; i < (p.quantity || 1); i++) {
        chips.push(`
          <div class="pbb-slot filled ${p.isPreorder ? 'preorder' : ''}">
            ${p.image ? `<img src="${p.image}" alt="">` : ''}
            <span class="pbb-slot-title">${p.title}${p.isPreorder ? ` <i>${t('preorder_tag')}</i>` : ''}</span>
            <button class="pbb-slot-x" type="button" data-id="${p.productId}" aria-label="Fjern ${(p.title || '').replace(/"/g, '&quot;')}">×</button>
          </div>`);
      }
    });
    const remaining = Math.max(0, state.targetQty - chips.length);
    for (let i = 0; i < remaining; i++) {
      chips.push(`<div class="pbb-slot empty"><span>${t('empty_slot')}</span></div>`);
    }
    els.slots.innerHTML = chips.join('');
    els.slots.querySelectorAll('.pbb-slot-x').forEach(b => b.addEventListener('click', () => removeOne(b.dataset.id)));
  }

  function renderSummary() {
    const price = bundlePrice();
    els.price.textContent = Core.formatPrice(price);
    const base = representativeBase(state.size);
    const full = totalSelected() >= state.targetQty
      ? state.selected.reduce((s, p) => s + p.price * (p.quantity || 1), 0)
      : base * state.targetQty;
    const save = full - price;
    const pct = full > 0 ? Math.round(save / full * 100) : 0;
    if (save > 0) {
      els.saveRow.hidden = false;
      els.saveAmount.textContent = Core.formatPrice(save);
      els.savePct.textContent = pct > 0 ? `(${pct}%)` : '';
    } else {
      els.saveRow.hidden = true;
    }

    const preorders = state.selected.filter(p => p.isPreorder);
    if (preorders.length > 0) {
      els.preorderNote.hidden = false;
      const titles = preorders.map(p => p.title).join(', ');
      // The whole order is HELD and ships together once the LAST pre-order item is
      // back in stock — so show the latest expected date among the pre-order items.
      const isos = preorders.map(p => p.shipDateISO).filter(Boolean).sort();
      let when = '';
      if (isos.length) {
        const latestISO = isos[isos.length - 1];
        const latest = preorders.find(p => p.shipDateISO === latestISO);
        if (latest && latest.shipDate) when = tf('preorder_when', { date: latest.shipDate });
      }
      const key = preorders.length === 1 ? 'preorder_note_one' : 'preorder_note_many';
      els.preorderDetail.textContent = tf(key, { titles: titles, when: when });
    } else {
      els.preorderNote.hidden = true;
    }
  }

  function renderProgress() {
    const total = totalSelected();
    if (els.countCurrent) els.countCurrent.textContent = total;
    if (els.countTarget) els.countTarget.textContent = state.targetQty;
    if (els.progressFill) {
      const pct = Math.max(0, Math.min(100, total / state.targetQty * 100));
      els.progressFill.style.width = pct + '%';
    }
  }

  function renderATC() {
    const total = totalSelected();
    const remaining = state.targetQty - total;
    const incomplete = remaining > 0;
    const label = incomplete
      ? (remaining === 1 ? t('need_one') : tf('need_many', { n: remaining }))
      : t('atc_ready') + ' — ' + Core.formatPrice(bundlePrice());

    els.atc.disabled = incomplete;
    els.atc.classList.toggle('incomplete', incomplete);
    els.atc.textContent = label;

    // Mobil-bar sync
    if (els.mbCta) {
      els.mbCta.disabled = incomplete;
      els.mbCta.classList.toggle('incomplete', incomplete);
      els.mbCta.textContent = label;
    }
    if (els.mbCount) els.mbCount.textContent = total + '/' + state.targetQty;
    if (els.mbPrice) els.mbPrice.textContent = Core.formatPrice(bundlePrice());
  }

  // ─── Detalje-modal ──────────────────────────────────────────────────────────
  function notesBlock(label, v) {
    const list = toList(v);
    if (list.length === 0) return '';
    return `<div class="pbb-notes-row"><span class="pbb-notes-label">${label}</span><span class="pbb-notes-vals">${list.join(' · ')}</span></div>`;
  }

  function openDetail(productId) {
    const p = state.byId.get(parseInt(productId, 10));
    if (!p) return;
    const v = variantForSize(p, state.size);
    const sel = findSelected(p.id);
    const inBundle = !!sel;
    const chips = toList(p.scentChips);
    const full = totalSelected() >= state.targetQty;

    // "Ofte købt sammen" — data-backed cross-sell fra frequently_bought_with-metafeltet
    const fbwProds = (p.fbw || [])
      .map(h => state.byHandle.get(h))
      .filter(x => x && x.id !== p.id && hasAvailableSize(x, state.size) && !findSelected(x.id));
    const fbwHtml = fbwProds.length ? `
      <div class="pbb-fbw">
        <span class="pbb-fbw-title">${t('fbw_title')}</span>
        <div class="pbb-fbw-items">
          ${fbwProds.slice(0, 3).map(x => `
            <button type="button" class="pbb-fbw-item" data-add-handle="${x.handle}">
              ${x.image ? `<img src="${x.image}" alt="">` : '<span class="pbb-fbw-ph"></span>'}
              <span class="pbb-fbw-name">${x.title}</span>
              <span class="pbb-fbw-plus" aria-hidden="true">+</span>
            </button>`).join('')}
        </div>
      </div>` : '';

    els.modalBody.innerHTML = `
      <div class="pbb-modal-head">
        <div class="pbb-modal-img">${p.image ? `<img src="${p.image}" alt="">` : ''}</div>
        <div>
          <h3 id="pbb-modal-title" class="pbb-modal-name">${p.title}</h3>
          <div class="pbb-modal-tags">${p.scentFamily ? `<span class="pbb-card-family">${p.scentFamily}</span>` : ''}${gender(p)}</div>
        </div>
      </div>
      ${chips.length ? `<div class="pbb-chips-row">${chips.map(c => `<span class="pbb-scent-chip">${c}</span>`).join('')}</div>` : ''}
      <div class="pbb-notes">
        ${notesBlock(t('notes_top'), p.topNotes)}
        ${notesBlock(t('notes_heart'), p.heartNotes)}
        ${notesBlock(t('notes_base'), p.baseNotes)}
      </div>
      ${fbwHtml}
      <div class="pbb-modal-actions">
        ${inBundle
          ? `<button class="pbb-modal-remove" type="button" data-id="${p.id}">${t('modal_remove')}</button>`
          : `<button class="pbb-modal-add" type="button" data-id="${p.id}" ${(!isAvailableV(v) || full) ? 'disabled' : ''}>${full ? t('box_full') : t('modal_add')}</button>`}
      </div>`;

    const addBtn = els.modalBody.querySelector('.pbb-modal-add');
    const remBtn = els.modalBody.querySelector('.pbb-modal-remove');
    if (addBtn) addBtn.addEventListener('click', () => { addOne(p.id); closeDetail(); });
    if (remBtn) remBtn.addEventListener('click', () => { removeProduct(p.id); closeDetail(); });
    els.modalBody.querySelectorAll('[data-add-handle]').forEach(b => {
      b.addEventListener('click', () => {
        const prod = state.byHandle.get(b.dataset.addHandle);
        if (prod) { addOne(prod.id); closeDetail(); }
      });
    });

    els.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    const closeBtn = els.modal.querySelector('.pbb-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDetail() {
    els.modal.hidden = true;
    document.body.style.overflow = '';
  }

  // ─── Tilføj til kurv ────────────────────────────────────────────────────────
  async function handleATC() {
    if (els.atc.disabled) return;
    els.atc.classList.add('loading');
    els.atc.setAttribute('aria-busy', 'true');
    const label = els.atc.textContent;
    els.atc.textContent = t('atc_adding');
    if (els.mbCta) { els.mbCta.disabled = true; els.mbCta.textContent = t('atc_adding'); }

    const items = state.selected.map(p => {
      const prod = state.byId.get(p.productId);
      const v = variantForSize(prod, state.size);
      return { id: p.variantId, quantity: p.quantity || 1, properties: Core.buildPreorderProperties(v) };
    });

    let cart;
    try {
      cart = await Core.addToCart(items);
    } catch (err) {
      console.error('Purabelle: kurv-fejl', err);
      announce('Der opstod en fejl. Prøv igen.');
      els.atc.classList.remove('loading');
      els.atc.removeAttribute('aria-busy');
      els.atc.textContent = label;
      return;
    }

    const added = totalSelected();
    try {
      Core.refreshCartUI(cart, added);
      announce(`Pakke tilføjet til kurv. ${added} parfumer.`);
      state.selected = [];
      renderAll();
    } catch (e) {
      // varerne ER i kurven — fald tilbage til reload
      window.location.reload();
    } finally {
      els.atc.classList.remove('loading');
      els.atc.removeAttribute('aria-busy');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
